/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { IDataServiceRequest, retailAction, OrgUnitsDataActions, ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import { QueryResultSettingsProxy } from './utilities/QueryResultSettingsProxy';

/**
 * Search Org Unit Locations action createInput method.
 * @param inputData - Current action context.
 * @returns Input needed to call the Search-org-unit-location API.
 */
export function createSearchOrgUnitLocationsInputFunc(
    inputData: ICreateActionContext<IGeneric<IAny>, IGeneric<IAny>>
): IDataServiceRequest {
    const querySettingsProxy = QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(inputData);
    return OrgUnitsDataActions.createSearchOrgUnitLocationsInput(querySettingsProxy, {});
}

export const retailActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/search-org-unit-locations',
    action: <IAction<ProductSearchResult[]>>retailAction,
    input: createSearchOrgUnitLocationsInputFunc
});

export default retailActionDataAction;
